import React from 'react';
import BrandLogo from './BrandLogo';
import './SocialMediaMarketingPage.css';

const smmImages = {
  hero: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/sicoal-media-mareting-page/Hero%20Image%20SMM.png',
  nextGen: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/sicoal-media-mareting-page/Next%20Gen%20Visuals.png',
  vibrant: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/sicoal-media-mareting-page/Vibrant%20Storyteller.png',
  vintage: 'https://raw.githubusercontent.com/hansrajparmarcom/sajagsadhana-photos/main/photos-BeyonDigital/sicoal-media-mareting-page/Vintage%20Soul%2C%20Modern%20Edge.png',
};

const marqueeItems = [
  'Brand Strategy',
  'Content Creation',
  'Influencer Marketing',
  'Analytics and Reporting',
  'Community Building',
  'Performance Marketing',
];

const expertiseCards = [
  {
    id: '01',
    title: 'Brand Strategy',
    description:
      'Deep audience research, positioning, and identity systems that make your brand unmissable.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
    ),
  },
  {
    id: '02',
    title: 'Content Creation',
    description:
      'Art-directed shoots, motion graphics, and copy that stops the scroll and converts.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 21l3.8-1 10.8-10.8a2.4 2.4 0 1 0-3.4-3.4L3.4 16.6 3 21z" />
      </svg>
    ),
  },
  {
    id: '03',
    title: 'Analytics',
    description:
      'Performance-obsessed ad management across Meta, TikTok, and LinkedIn with full-funnel attribution.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <path d="M3 14h4l3-9 4 14 3-8h4" />
      </svg>
    ),
  },
  {
    id: '04',
    title: 'Influencer Marketing',
    description:
      'Curated creator collaborations that align with your values and drive authentic engagement.',
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6">
        <circle cx="12" cy="8" r="4" />
        <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
      </svg>
    ),
  },
];

const styleShowcaseCards = [
  {
    title: 'Vintage Soul, Modern Edge',
    description:
      'A nostalgic blend of grain textures and retro palettes, reimagined for today digital landscape.',
    image: smmImages.vintage,
  },
  {
    title: 'Vibrant Storyteller',
    description:
      'Maximalist layouts and saturated palettes designed to pop off the screen and demand attention.',
    image: smmImages.vibrant,
  },
  {
    title: 'Next-Gen Visuals',
    description:
      'Sharp, geometric aesthetics featuring dark modes and neon accents to signal innovation and precision.',
    image: smmImages.nextGen,
  },
];

const testimonialCards = [
  {
    quote:
      "BeyonDigital transformed our social media into a true 360° brand ecosystem. We saw stronger retention, better community trust, and stronger funnel movement.",
    name: 'David Chen',
    role: 'Founder of Solstice App',
  },
  {
    quote:
      "Breaking through the noise felt impossible until we partnered with BeyonDigital. They helped us find our voice in a way that feels authentic and modern.",
    name: 'Ananya Iyer',
    role: 'Director of Marketing, Nila Home',
  },
  {
    quote:
      "They linked our social campaigns with measurable business outcomes. Our paid social now works as a predictable growth layer.",
    name: 'Vihaan Mehta',
    role: 'VP, Urban Root',
  },
];

export default function SocialMediaMarketingPage() {
  return (
    <div className="smm-page">
      <nav className="smm-nav">
        <BrandLogo className="smm-nav__logo" size="nav" />
        <ul className="smm-nav__links">
          <li>
            <a href="#work">Style</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
        </ul>
        <a href="#contact" className="smm-nav__cta">
          Contact
        </a>
      </nav>

      <section className="smm-hero">
        <div className="smm-hero__visual">
          <img
            src={smmImages.hero}
            alt="Social media marketing hero"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </div>
        <div className="smm-hero__content">
          <p className="smm-hero__eyebrow">Est. 2026 - London</p>
          <h1>
            Redefining
            <br />
            <em>the Digital</em>
            <br />
            Storytelling
          </h1>
          <p>
            We blend data-driven strategy with high-end aesthetics to scale your
            brand presence.
          </p>
          <div className="smm-hero__actions">
            <a href="#work" className="smm-btn smm-btn--dark">
              Explore Styles
            </a>
            <a href="#about" className="smm-btn smm-btn--ghost">
              Our Story ↗
            </a>
          </div>
          <div className="smm-proof">
            <div>
              <strong>20+</strong>
              <span>Brands Scaled</span>
            </div>
            <div>
              <strong>142%</strong>
              <span>Engagement Lift</span>
            </div>
            <div>
              <strong>9.1x</strong>
              <span>Avg. ROIS</span>
            </div>
          </div>
        </div>
      </section>

      <section className="smm-marquee">
        <div className="smm-marquee__track">
          {[...marqueeItems, ...marqueeItems].map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              <span>{item}</span>
              <span className="smm-marquee__dot">·</span>
            </React.Fragment>
          ))}
        </div>
      </section>

      <section className="smm-section" id="services">
        <header className="smm-section__header">
          <p className="smm-section__tag">Expertise In</p>
          <h2>
            Scalling
            <br />
            <em>every brand with</em>
          </h2>
        </header>
        <div className="smm-grid smm-grid--expertise">
          {expertiseCards.map((card) => (
            <article className="smm-expertise-card" key={card.title}>
              <p className="smm-expertise-card__num">{card.id}</p>
              <div className="smm-expertise-card__icon">{card.icon}</div>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="smm-section" id="work">
        <header className="smm-section__header smm-section__header--showcase">
          <p className="smm-section__tag">Styles we</p>
          <h2>
            Work with
            <br />
            <em>That speaks for themselves.</em>
          </h2>
        </header>

        <div className="smm-grid smm-grid--showcase">
          {styleShowcaseCards.map((card) => (
            <article className="smm-showcase-card" key={card.title}>
              <div className="smm-showcase-card__image">
                <img
                  src={card.image}
                  alt={card.title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>
              <div className="smm-showcase-card__body">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="smm-section">
        <header className="smm-section__header smm-section__header--clients">
          <p className="smm-section__tag">A Word</p>
          <h2>
            From our
            <br />
            <em>Beloved Clients</em>
          </h2>
        </header>

        <div className="smm-grid smm-grid--clients">
          {testimonialCards.map((card) => (
            <blockquote className="smm-client-card" key={card.name}>
              <span className="smm-client-card__mark" aria-hidden="true">
                "
              </span>
              <p>{card.quote}</p>
              <cite>
                <strong>{card.name}</strong>
                <span>{card.role}</span>
              </cite>
            </blockquote>
          ))}
        </div>
      </section>

      <section className="smm-cta" id="contact">
        <div className="smm-cta__inner">
          <h2>
            Ready to go beyond digital?
            <br />
            <em>The algorithm waits for no one.</em>
          </h2>
          <a href="mailto:sdevarsh54@beyondigital.co.uk" className="smm-btn smm-btn--dark">
            Start your growth phase
          </a>
        </div>
      </section>

      <footer className="smm-footer" id="about">
        <div className="smm-footer__top">
          <div className="smm-footer__brand">
            <BrandLogo size="footer" asLink={false} variant="dark" />
            <p>Redefining what social media can do for the modern enterprise.</p>
          </div>

          <div className="smm-footer__links">
            <div>
              <h4>Agency</h4>
              <a href="/">About</a>
              <a href="/">Work</a>
              <a href="/">Careers</a>
            </div>
            <div>
              <h4>Services</h4>
              <a href="/">Strategy</a>
              <a href="/">Content</a>
              <a href="/">Paid Social</a>
            </div>
            <div>
              <h4>Connect</h4>
              <a href="https://www.instagram.com/beyondigital.co/">Instagram</a>
              <a href="/">LinkedIn</a>
              <a href="/">Twitter/X</a>
            </div>
          </div>
        </div>

        <div className="smm-footer__bottom">London - India - Dubai</div>
      </footer>
    </div>
  );
}
